import React from 'react';
export function Footer() {
  return <footer className="bg-cream py-8 border-t border-green-emerald/15 text-center px-4" data-id="element-123">
      <div className="max-w-4xl mx-auto" data-id="element-124">
        <p className="text-ink-muted text-sm" data-id="element-125">
          © {new Date().getFullYear()} Mega Pack Ciencias de la Salud en el
          Aula — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}